import React from 'react';
import TranslatedCopy from '../../intl/translated-copy';
import Tooltip from './tooltip-my-trips'; 

const RenderReservationOrETicketLabel = () => {
  return (
    <div>
      <TranslatedCopy
        className='PNRLookupForm-ticketNumberLabel'
        copyID='CHECK_IN_RESERVATION_TICKET_NUMBER' />
      <Tooltip
        labelID='reservation-label'
        copyID='MYB_NEW_MENU_HEADER_TOOLTIP'
        position={ {
          'small': 'right',
          'medium': 'right',
          'medium-high': 'right',
          'large': 'right',
        } }
        tooltipID='reservation' />
    </div>
  );
};

export default RenderReservationOrETicketLabel;